import { COMMON } from '../../Enum/EndPoint/CommonEndpoint';

export const BROADCAST_URL = Object.freeze({
  INITIATE: filter => COMMON.BROADCASTSYSTEM + COMMON.INITIATE + COMMON.FILTER(filter),
  LIST: (page, limit, order, filter) =>
    COMMON.BROADCASTSYSTEM + COMMON.LIST_FILTER(page, limit, order, filter),
  DETAIL: id => COMMON.BROADCASTSYSTEM + COMMON.INDEX + id,
  ADMIN: COMMON.INFINITE + COMMON.USER,
});
